import React from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  SectionWixFooter,
  TranslatedContent,
  ISectionProps,
  ITextSection,
} from '@wix/shoutout-email-react';
import { WixComponentTypes, WixFooterType } from '@wix/shoutout-email-model-v3';

interface PropTypes extends ISectionProps {
  isRtl: boolean;
  section: ITextSection & { footerType: WixFooterType };
  content: TranslatedContent;
  backgroundColor: string;
  columnCssClass: string;
  cssClass: string;
  experiments: Record<string, string>;
}

export const SectionWixFooterWithContent = (props: PropTypes) => {
  const { t } = useTranslation();
  const content = {
    dontReply: t('wix.footer.content.dont.reply'),
    helpCenter: t('wix.footer.content.help.center'),
    helpCenterUrl: t('wix.footer.content.help.center.url'),
    privacyPolicy: t('wix.footer.content.privacy.policy'),
    privacyPolicyUrl: t('wix.footer.content.privacy.policy.url'),
    termsOfUse: t('wix.footer.content.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.terms.of.use.url'),
    companyAddressLine: t('wix.footer.content.company.address'),
  };

  const paymentsContent = {
    ...content,
    termsOfUse: t('wix.footer.content.payments.terms.of.use'),
    termsOfUseUrl: t('wix.footer.content.payments.terms.of.use.url'),
  };

  return (
    <SectionWixFooter
      {...props}
      content={
        props.section.footerType !== WixComponentTypes.payments
          ? content
          : paymentsContent
      }
    />
  );
};
